<template>

    <div class="container pt-2">

        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="text-left py-3">
                    <h1 class="text-weight-900 text-primary">Wastes</h1>
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="text-right py-3">
                    <button v-on:click="createModal" class="btn btn-primary">Record Waste</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 py-2">
                </div>
            <div class="col-md-6 col-sm-12 py-2">
            
                    <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker pb-2">
                                <template #input="picker" style="width: 100% !important;">
                                                            <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                            <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
                                </template>
                    </date-range-picker>
            </div>
        </div>
        <b-table :items="wastesTable.items" :fields="wastesTable.fields" sort-icon-left responsive="sm" @row-clicked="rowSelected">
            <template #cell(estimated_amount)="data">
                    <p> {{ convertCurrencyToShillings(data.item.estimated_amount) }}</p>
</template>

<template #cell(status)="data">
    <p v-if="data.item.status === null" class="text-dark"> Pending</p>
    <p v-else-if="data.item.status === 0" class="text-danger"> Rejected</p>
    <p v-else="data.item.status === 1" class="text-success"> Approved</p>
</template>
    </b-table>
        <!--Page modals-->
        <b-modal ref="createwastemodal" id="modal-center" hide-footer hide-header static>
            <div class="text-center">
                <h2 class="text-weight-700 text-primary">Register Waste</h2>
                <hr/>
                <div class="container">
                    <form class="form" @submit.prevent="createWaste">
                        <p class="float-left">Search Item</p>
                        <input class="form-control" type="text" v-model="wasteForm.searchTerm" placeholder="Enter name of item" />
                        <ul class="product-list" v-if="showSuggestions">
                            <li class="m-0 py-1" v-for="product in suggestedProducts" :key="product.id" @click="handleSelection(product)">
                                {{ product.product }}
                            </li>
                        </ul>
                        <div class="form-group">
                            <p class="float-left">Quantities</p>
                            <input class="form-control" type="number" v-model="wasteForm.wasteQty" placeholder="Quantity" />
                        </div>
                        <div class="form-group">
                            <p class="float-left">Reason for waste</p>
                            <textarea class="form-control" rows="3" v-model=wasteForm.reason placeholder="What is the cause of the waste/reason" required></textarea>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-outline-primary btn-block btn-sm">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </b-modal>
        <b-modal ref="selectedWasteModal" id="modal-center" hide-footer static>
            <div class="text-center">
                <h2 class=" text-dark">Waste Details</h2>
                <hr/>
                <div class="container">
                   <ul class="list-group text-left">
                    <li class="py-2 border-bottom m-0"><span class="text-primary">Item</span>: {{ wastesTable.selectedWaste.item }}</li>
                    <li v-if="wastesTable.selectedWaste.estimated_amount" class="py-2 border-bottom m-0"><span class="text-primary">Amount</span>: {{ convertCurrencyToLocal(wastesTable.selectedWaste.estimated_amount) }}</li>
                    <li v-if="wastesTable.selectedWaste.estimated_amount" class="py-2 border-bottom m-0"><span class="text-primary">Quantity</span>: {{ wastesTable.selectedWaste.qty }}</li>
                    <li v-if="wastesTable.selectedWaste.user" class="py-2 border-bottom m-0"><span class="text-primary">Created by</span>: <span class="text-capitalize">{{ wastesTable.selectedWaste.user.name }}</span> </li>
                    <li class="py-2 border-bottom m-0"><span class="text-primary">Date</span>: {{ wastesTable.selectedWaste.date }}</li>
                   </ul>
                    
                </div>
            </div>
            <div class="btn-group">
                <a v-if="wastesTable.selectedWaste.status === null" @click="deleteWaste()"  class="btn btn-dark btn-sm mx-1 rounded">Delete</a>
                <a v-if="userRole === 'Admin' || hasPermission('can manage wastes')  && wastesTable.selectedWaste.status === null" @click="approveOrReject(2)" class="btn btn-danger btn-sm mx-1 rounded">Reject</a>
                <a v-if="userRole === 'Admin' || hasPermission('can manage wastes') && wastesTable.selectedWaste.status === null" @click="approveOrReject(1)"  class="btn btn-success btn-sm mx-1 rounded">Approve</a>
                
            
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker"; 
    export default {
        name: 'expenses',
        components: {
            DateRangePicker
        },
        data() {

            return {
                wastesTable: {
                    items: [],
                    fields: [{
                            key: 'item',
                            sortable: true,
                        },
                        {
                            key: 'estimated_amount',
                            sortable: true,
                        },
                        {
                            key: 'status',
                        },
                        {
                            key: 'date',
                            sortable: true,
                        }
                    ],
                    selectedWaste: {}
                },
                userRole: '',
                wasteForm: {
                    wasteQty: 0,
                    reason: '',
                    searchTerm: '',
                    selectedItemWasted: ''
                },
                inventoryItems: [],
                isItemSelected: false,
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,
            }
        },
        computed: {
            ...mapGetters(['userDetails']),
            filteredItems() {
                if (!this.wasteForm.searchTerm) {
                    return this.items;
                }
                const searchTerm = this.wasteForm.searchTerm.toLowerCase();
                return this.inventoryItems.filter(item =>
                    item.product.toLowerCase().includes(searchTerm)
                );
            },
            suggestedProducts() {
                const limit = 5;
                return this.filteredItems.slice(0, limit);
            },
            showSuggestions() {
                return this.wasteForm.searchTerm.length > 0 && this.suggestedProducts.length > 0 && !this.isItemSelected;
            },
       
     

        },
        watch: {
            dateRange: {
                deep: true,
                handler(after, before) {
                    if (after.startDate && after.endDate) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                        const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time

                        urlParams.set('start-date', startDateString);
                        urlParams.set('end-date', endDateString);

                        window.history.replaceState(null, null, '?' + urlParams.toString());
                     }
                    this.getWastes()
                }
               
            },
        },
        mounted() {
            this.getWastes();
        },
        methods: {
            // open create expense modal
            createModal() {
                this.getProductsCount()
                this.$refs['createwastemodal'].show();
            },
            hasPermission(permissionName) {
                 return (this.userDetails?.permissions || []).some(permission => permission.name === permissionName);
            },
            rowSelected(items) {
                this.wastesTable.selectedWaste = items;
                this.$refs['selectedWasteModal'].show();
            },
            handleSelection(product) {
                this.wasteForm.searchTerm = product.product;
                this.wasteForm.selectedItemWasted = product;
                this.isItemSelected = true;
            },
            hideSuggestions() {
                setTimeout(() => {
                    this.isItemSelected = false;
                }, 200);
            },
            formatDate(date, format) {
                return moment(date).format(format);
            },
            getWastes() {
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/wastes',
                {params:{
                    startdate: urlParams.get('start-date'),
                    enddate: urlParams.get('end-date'),
                   
                 }}
                )
                    .then(result => {
                        this.userRole = result.data.role
                        let itemArray = [];
                        $.each(result.data.wastes, function(key, value) {
                            // Date
                            let createddate = moment(value.created_at).format('HH:mm DD-MM-YYYY');
                            itemArray.push({
                                'wasteId': value.id,
                                'item': (value.products) ? value.products.product : '',
                                'estimated_amount': value.estimated_amount,
                                'status': value.status,
                                'user': value.user,
                                'date': createddate,
                                'qty': value.qty,
                                'product': (value.products) ? value.products : {},
                            })
                        });
                        this.wastesTable.items = itemArray;
                    });
            },
            getProductsCount() {
                axios.get('/api/all-items-and-count').then(results => {
                    this.inventoryItems = results.data.items
                }).catch(error => {})
            },
            approveOrReject(action) {
                axios.post('/api/wastes-action', {
                        action: (action === 1) ? 'approve' : 'reject',
                        wasteId: this.wastesTable.selectedWaste.wasteId,
                        qty: this.wastesTable.selectedWaste.qty,
                        prodId: this.wastesTable.selectedWaste.product.id
                    })
                    .then(result => {
                        if (result.status == 200) {
                            this.getWastes();
                            this.$refs['selectedWasteModal'].hide();
                            this.$toasts.push({
                                type: 'success',
                                message: 'Action successful',
                            });
                        } else {
                        }
                    });
            },
            deleteWaste() {
                axios.post('/api/wastes-action', {
                        action: 'delete',
                        wasteId: this.wastesTable.selectedWaste.wasteId,
                        qty: this.wastesTable.selectedWaste.qty,
                        prodId: this.wastesTable.selectedWaste.product.id
                    })
                    .then(result => {
                        if (result.status == 200) {
                            this.$refs['selectedWasteModal'].hide();
                            this.$toasts.push({
                                type: 'success',
                                message: 'Deleted successful',
                            });
                            this.getWastes();
                        } else {
                        }
                    });
            },
            createWaste() {
                axios.post('/api/waste/create', {
                        ...this.wasteForm
                    })
                    .then(result => {
                        if (result.data.status == 200) {
                            this.getWastes();
                            this.$refs['createwastemodal'].hide();
                            this.$toasts.push({
                                type: 'success',
                                message: result.data.message,
                            });
                        } else {
                        }
                    });
            },
        }
    }
</script>

<style>
    .product-list li:hover {
        background-color: #f8f9fa;
        /* Set the hover background color */
    }
    .product-list li:nth-child(even) {
        background-color: #ffffff;
        /* Set the even row background color */
    }
    .product-list li:nth-child(odd) {
        background-color: #f5f5f5;
        /* Set the odd row background color */
    }
</style>
